import { render, staticRenderFns } from "./GradingTable.vue?vue&type=template&id=58d95056&scoped=true&"
import script from "./GradingTable.vue?vue&type=script&lang=js&"
export * from "./GradingTable.vue?vue&type=script&lang=js&"
import style0 from "./GradingTable.vue?vue&type=style&index=0&id=58d95056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d95056",
  null
  
)

export default component.exports